<template>
  <div>
    <div :class="[unreadBackground, computedColumns]" class="notification-cell-container">

      <!--       Notification Account -->
      <div class="notification-cell margin-auto" v-if="this.displayAccountColumn">
        <div class="notification-header notification-header-bold">{{
            notification.account_name
          }}
        </div>
      </div>

      <!-- Notification Name -->
      <div class="notification-cell notification-cell-name">
        <div class="flex">
          <notification-type-icon :grayscale="grayscaleIcon" :notification-type="this.notification.type || false"/>
          <div>
            <div class="notification-header notification-header-bold">{{
                notification.header
              }}
            </div>
          </div>
        </div>
      </div>

      <div class="notification-cell notification-cell-name">
          <div>
            <div class="notification-header">{{
                notification.created_at_formatted
              }}
            </div>
          </div>
      </div>


      <!-- Order information -->
      <div class="notification-cell clickable notification-cell-name">
        <div v-if="notification.order" class="notification-header-clickable">
          <div>
            <a target="_blank" :href="notification.order_link">
              {{ notification.order.name }} (#{{ notification.order.id }})
            </a>
          </div>
          <div v-if="this.notification.order.due_at" class="notification-footer">
            <div class="notification-sub-header">Due date: {{ this.notification.order.due_at }}
            </div>
          </div>
        </div>
      </div>
      <div class="notification-cell clickable notification-cell-name">
        <div v-if="notification.actions">
          <notification-actionable :order-id="notification.order_id" :action="notification.actions" :comment-count="notification.order_comment_count"/>
        </div>
      </div>

      <!-- View Notification in popup column -->
      <div class="notification-cell notification-cell-flag">
        <img
            class="notification-type-icon clickable"
            title="View Delivered Notification"
            @click="showNotificationEmail"
            :src="viewNotificationIcon(notification)"
        />
      </div>

        <div class="notification-cell notification-cell-flag">
            <b :class="getStatusColor(notification.was_success)">{{ getStatusText(notification.was_success) }}</b>
        </div>
      <!-- Flagged column -->
      <div class="notification-cell notification-cell-flag">
        <notification-flag title="Flag Notification" :flagged="this.notification.is_flagged" v-on:flag-toggle="toggleNotificationFlagged"/>
      </div>

    </div>
    <acclaro-modal v-if="showModal" @close="showModal = false">
      <div slot="header" class="notification-header">
        <!--        <div>To: {{this.getNotificationRecipients('to').join(', ')}}</div>-->
        <!--        <div>CC: {{this.getNotificationRecipients('cc').join(', ')}}</div>-->
      </div>
      <div slot="body" class="html-notification-container" @click.prevent v-html="notificationEmail"></div>
    </acclaro-modal>
  </div>
</template>

<script>

import axios from 'axios';
import NotificationTypeIcon from "./notification-type-icon.vue";
import NotificationFlag from './notification-flag.vue';
import NotificationActionable from './notification-actionable.vue';
import AcclaroModal from './../Modal/acclaro-modal.vue';
import './user-notifications.scss';
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  data: function () {
    return {
      showModal: false,
      notificationEmail: ''
    };
  },
  name: "notification.vue",
  components: {NotificationTypeIcon, NotificationFlag, NotificationActionable, AcclaroModal},
  props: ['notification'],
  computed: {
    ...mapState('AuthStore', {
      'sessionUser': 'user'
    }),
    ...mapState('PortalNotificationStore', [
      'user',
      'showNotificationsFor',
      'account',
      'assignedOnly',
      'displayAccountColumn',
    ]),
    computedColumns () {
      return this.assignedOnly ? 'notification-show-all-cols' : 'notification-show-cols';
    },
    unreadBackground () {
      return this.notification.new ? "background-unread" : "background-read";
    },
    grayscaleIcon () {
      return this.notification.new ? "" : "grayscale";
    },
    ...mapGetters('PortalNotificationStore', [
      'requestUrl',
    ]),
  },
  methods: {
    showNotificationEmail () {
      axios.get(`/web-email/html/${this.notification.notification_log_id}`).then((res) => {
        this.notificationEmail = `<span> ${res.data} </span>`;
        this.showModal = true;
      });
    },
    ...mapActions('PortalNotificationStore', [
      'fetchNotifications'
    ]),
    getStatusColor(status) {
      if (status === 2) {
        return 'yellow';
      } else {
        return status === 1 ? 'green' : 'red';
      }
    },
    getStatusText(status) {
      if (status === 2) {
        return 'Skipped';
      } else {
        return status === 1 ? 'Success' : 'Failed';
      }
    },
    viewComment () {
      const orderId = this.notification.order_id;
      // todo convert legacy to vue component
      $.get('/ajax/reports',
          {report: 'order-comments', id: orderId}, function (data) {
            let content = '<div class="popup-comment order-comments">' + data + '</div>';

            let popup = new PopupConfirmDialog(content,
                {
                  messageTitle: 'Order ' + orderId + ' Comments',
                  confirmCallback: function () {
                    $(`<a href="/orders/view/${orderId}/?t=comment" target="blank"></a>`)[0].click();
                  },
                  confirmButtonText: 'Open Order',
                  cancelButtonText: 'Close',
                  showConfirmButton: true,
                  showCancelButton: true,
                  showInput: false
                }
            );
            popup.show();
          }, "html");
    },
    viewNotificationIcon(notification){
      return notification.is_pm_notification ? "/images/notifications/notification-PM.svg" : "/images/notifications/view-email.svg";
    },
    toggleNotificationFlagged () {
      const flagged = this.notification.is_flagged ? 1 : 0;
      let request;
      if (this.showNotificationsFor === 'user') {
        if (auth.id !== this.user.id) {
          return alert('Cannot flag another users notification');
        }
        request = axios.post('/notifications/user/flag', {
          user_notification_id: this.notification.id,
          value: !flagged
        });
      }
      else if (this.showNotificationsFor === 'account') {
        request = axios.post('/notifications/account/flag', {
          account_notification_id: this.notification.id,
          value: !flagged
        });
      } else if (this.showNotificationsFor === 'assigned') {
        request = axios.post('/notifications/account/flag', {
          account_notification_id: this.notification.id,
          value: !flagged
        });
      }
      request.then(() => {
        this.fetchNotifications(this.requestUrl)
      }).catch(() => {
        console.log('Unable to set flag...');
      });
    },
    getNotificationRecipients (type) {
      const recipients = JSON.parse(this.notification?.notification_log?.sent_to);
      return recipients[type] || [];
    }
  },

};
</script>
